module.exports = __webpack_public_path__ + "img/ctrl-bwecp-stub-down-+i.c92ff662.svg";